(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-brand-woman"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aura-brand-woman-gallery')) {
    customElements.define('aura-brand-woman-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.rail = this.querySelector('.aura-brand-woman__rail');
        this.slides = Array.from(this.querySelectorAll('.aura-brand-woman__slide'));
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.counter = this.querySelector('[data-gallery-counter]');
        this.index = 0;
        if (!this.rail || !this.slides.length) return;
        const options = { signal: this.abortController.signal };
        this.previous.addEventListener('click', () => this.go(this.index - 1), options);
        this.next.addEventListener('click', () => this.go(this.index + 1), options);
        this.rail.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.rail.addEventListener('scroll', () => {
          if (!this.drag) this.update(Math.round(this.rail.scrollLeft / this.rail.clientWidth));
        }, { ...options, passive: true });
        this.rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          event.preventDefault();
          this.drag = { x: event.clientX, left: this.rail.scrollLeft };
          this.rail.classList.add('is-dragging');
          this.rail.setPointerCapture(event.pointerId);
        }, options);
        this.rail.addEventListener('pointermove', (event) => {
          if (this.drag) this.rail.scrollLeft = this.drag.left + this.drag.x - event.clientX;
        }, options);
        const finishDrag = (event) => {
          if (!this.drag) return;
          this.drag = null;
          this.rail.classList.remove('is-dragging');
          if (this.rail.hasPointerCapture(event.pointerId)) this.rail.releasePointerCapture(event.pointerId);
          this.go(Math.round(this.rail.scrollLeft / this.rail.clientWidth));
        };
        this.rail.addEventListener('pointerup', finishDrag, options);
        this.rail.addEventListener('pointercancel', finishDrag, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.go(index, false);
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, false));
        this.resizeObserver.observe(this.rail);
        this.update(0);
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }
      update(index) {
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
        this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== this.index)));
      }
      go(index, animate = true) {
        const target = Math.max(0, Math.min(this.slides.length - 1, index));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollTo({ left: target * this.rail.clientWidth, behavior: animate && !reducedMotion ? 'smooth' : 'instant' });
        this.update(target);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-home-campaign"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aura-home-gallery')) {
  customElements.define('aura-home-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.items = [];
      this.index = 0;
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-gallery-open]');
        if (opener && this.contains(opener)) {
          event.preventDefault();
          const group = opener.dataset.galleryOpen;
          this.items = Array.from(this.querySelectorAll('[data-gallery-item]')).filter((item) => group === 'all' ? item.dataset.galleryAll !== 'false' : item.dataset.galleryGroup === group);
          if (group === 'all') this.items.sort((a, b) => Number(a.dataset.gallerySort || 0) - Number(b.dataset.gallerySort || 0));
          if (!this.items.length) return;
          this.index = Math.max(0, this.items.findIndex((item) => item.dataset.galleryItem === opener.dataset.galleryStart));
          this.querySelector('[data-gallery-title]').textContent = opener.dataset.galleryHeading || this.dataset.galleryHeading || '';
          this.previousOverflow = document.body.style.overflow;
          this.opener = opener;
          this.update();
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          return;
        }
        if (event.target.closest('[data-gallery-close]')) this.dialog.close();
        if (event.target.closest('[data-gallery-prev]')) this.move(-1);
        if (event.target.closest('[data-gallery-next]')) this.move(1);
        if (event.target === this.dialog) this.dialog.close();
        const railButton = event.target.closest('[data-category-previous],[data-category-next]');
        if (railButton) {
          const rail = this.querySelector('[data-category-rail]');
          const direction = railButton.hasAttribute('data-category-next') ? 1 : -1;
          rail.scrollBy({left: rail.clientWidth * .78 * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      }, {signal});
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.opener?.focus({preventScroll:true});
      }, {signal});
      const rail = this.querySelector('[data-category-rail]');
      if (rail) {
        const controls = () => {
          this.querySelector('[data-category-previous]').disabled = rail.scrollLeft <= 1;
          this.querySelector('[data-category-next]').disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
        };
        rail.addEventListener('scroll', controls, {signal, passive:true});
        this.observer = new ResizeObserver(controls);
        this.observer.observe(rail);
        controls();
      }
    }
    update() {
      const item = this.items[this.index];
      const image = this.querySelector('[data-gallery-image]');
      image.src = item.dataset.gallerySrc;
      image.alt = item.dataset.galleryAlt || '';
      this.querySelector('[data-gallery-count]').textContent = `LOOK ${this.index + 1} OF ${this.items.length}`;
    }
    move(direction) {
      if (!this.items.length) return;
      this.index = (this.index + direction + this.items.length) % this.items.length;
      this.update();
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        document.body.style.overflow = this.previousOverflow || '';
        this.dialog.close();
      }
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-home-categories"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aura-home-gallery')) {
  customElements.define('aura-home-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.items = [];
      this.index = 0;
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-gallery-open]');
        if (opener && this.contains(opener)) {
          event.preventDefault();
          const group = opener.dataset.galleryOpen;
          this.items = Array.from(this.querySelectorAll('[data-gallery-item]')).filter((item) => group === 'all' ? item.dataset.galleryAll !== 'false' : item.dataset.galleryGroup === group);
          if (group === 'all') this.items.sort((a, b) => Number(a.dataset.gallerySort || 0) - Number(b.dataset.gallerySort || 0));
          if (!this.items.length) return;
          this.index = Math.max(0, this.items.findIndex((item) => item.dataset.galleryItem === opener.dataset.galleryStart));
          this.querySelector('[data-gallery-title]').textContent = opener.dataset.galleryHeading || this.dataset.galleryHeading || '';
          this.previousOverflow = document.body.style.overflow;
          this.opener = opener;
          this.update();
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          return;
        }
        if (event.target.closest('[data-gallery-close]')) this.dialog.close();
        if (event.target.closest('[data-gallery-prev]')) this.move(-1);
        if (event.target.closest('[data-gallery-next]')) this.move(1);
        if (event.target === this.dialog) this.dialog.close();
        const railButton = event.target.closest('[data-category-previous],[data-category-next]');
        if (railButton) {
          const rail = this.querySelector('[data-category-rail]');
          const direction = railButton.hasAttribute('data-category-next') ? 1 : -1;
          rail.scrollBy({left: rail.clientWidth * .78 * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      }, {signal});
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.opener?.focus({preventScroll:true});
      }, {signal});
      const rail = this.querySelector('[data-category-rail]');
      if (rail) {
        const controls = () => {
          this.querySelector('[data-category-previous]').disabled = rail.scrollLeft <= 1;
          this.querySelector('[data-category-next]').disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
        };
        rail.addEventListener('scroll', controls, {signal, passive:true});
        this.observer = new ResizeObserver(controls);
        this.observer.observe(rail);
        controls();
      }
    }
    update() {
      const item = this.items[this.index];
      const image = this.querySelector('[data-gallery-image]');
      image.src = item.dataset.gallerySrc;
      image.alt = item.dataset.galleryAlt || '';
      this.querySelector('[data-gallery-count]').textContent = `LOOK ${this.index + 1} OF ${this.items.length}`;
    }
    move(direction) {
      if (!this.items.length) return;
      this.index = (this.index + direction + this.items.length) % this.items.length;
      this.update();
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        document.body.style.overflow = this.previousOverflow || '';
        this.dialog.close();
      }
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-home-nights"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aura-home-gallery')) {
  customElements.define('aura-home-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.items = [];
      this.index = 0;
      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-gallery-open]');
        if (opener && this.contains(opener)) {
          event.preventDefault();
          const group = opener.dataset.galleryOpen;
          this.items = Array.from(this.querySelectorAll('[data-gallery-item]')).filter((item) => group === 'all' ? item.dataset.galleryAll !== 'false' : item.dataset.galleryGroup === group);
          if (group === 'all') this.items.sort((a, b) => Number(a.dataset.gallerySort || 0) - Number(b.dataset.gallerySort || 0));
          if (!this.items.length) return;
          this.index = Math.max(0, this.items.findIndex((item) => item.dataset.galleryItem === opener.dataset.galleryStart));
          this.querySelector('[data-gallery-title]').textContent = opener.dataset.galleryHeading || this.dataset.galleryHeading || '';
          this.previousOverflow = document.body.style.overflow;
          this.opener = opener;
          this.update();
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          return;
        }
        if (event.target.closest('[data-gallery-close]')) this.dialog.close();
        if (event.target.closest('[data-gallery-prev]')) this.move(-1);
        if (event.target.closest('[data-gallery-next]')) this.move(1);
        if (event.target === this.dialog) this.dialog.close();
        const railButton = event.target.closest('[data-category-previous],[data-category-next]');
        if (railButton) {
          const rail = this.querySelector('[data-category-rail]');
          const direction = railButton.hasAttribute('data-category-next') ? 1 : -1;
          rail.scrollBy({left: rail.clientWidth * .78 * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
      }, {signal});
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.opener?.focus({preventScroll:true});
      }, {signal});
      const rail = this.querySelector('[data-category-rail]');
      if (rail) {
        const controls = () => {
          this.querySelector('[data-category-previous]').disabled = rail.scrollLeft <= 1;
          this.querySelector('[data-category-next]').disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
        };
        rail.addEventListener('scroll', controls, {signal, passive:true});
        this.observer = new ResizeObserver(controls);
        this.observer.observe(rail);
        controls();
      }
    }
    update() {
      const item = this.items[this.index];
      const image = this.querySelector('[data-gallery-image]');
      image.src = item.dataset.gallerySrc;
      image.alt = item.dataset.galleryAlt || '';
      this.querySelector('[data-gallery-count]').textContent = `LOOK ${this.index + 1} OF ${this.items.length}`;
    }
    move(direction) {
      if (!this.items.length) return;
      this.index = (this.index + direction + this.items.length) % this.items.length;
      this.update();
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        document.body.style.overflow = this.previousOverflow || '';
        this.dialog.close();
      }
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-product-main"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aura-product')) {
  customElements.define('aura-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('pointermove', event => {
        const trigger = event.target.closest('[data-image-zoom]');
        if (!trigger || event.pointerType === 'touch') return;
        const rect = trigger.getBoundingClientRect();
        trigger.style.setProperty('--aura-zoom-x', `${Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100))}%`);
        trigger.style.setProperty('--aura-zoom-y', `${Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100))}%`);
      });
      this.addEventListener('click', event => {
        const dialog = this.querySelector('[data-image-dialog]');
        const zoomTrigger = event.target.closest('[data-image-zoom]');
        if (zoomTrigger) {
          const image = dialog.querySelector('[data-zoom-image]');
          image.src = zoomTrigger.dataset.imageSrc;
          image.alt = zoomTrigger.dataset.imageAlt;
          dialog.showModal();
          return;
        }
        if (event.target.closest('[data-zoom-close]') || event.target === dialog) { dialog.close(); return; }
        const option = event.target.closest('[data-option-link]');
        if (option && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          if (!this.busy && option.getAttribute('aria-current') !== 'true') this.changeOption(option);
          return;
        }
        const thumbnail = event.target.closest('[data-media-target]');
        if (thumbnail) { event.preventDefault(); this.showMedia(thumbnail.dataset.mediaTarget); return; }
        const quantityButton = event.target.closest('[data-quantity]');
        if (quantityButton) {
          const input = this.querySelector('input[name="quantity"]');
          quantityButton.dataset.quantity === 'plus' ? input.stepUp() : input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      this.addEventListener('submit', event => {
        if (event.target.matches('[data-aura-form]') && (!event.submitter || event.submitter.matches('[name="add"]'))) {
          event.preventDefault();
          if (!this.busy) this.addToCart(event.target);
        }
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
    showMedia(id) {
      this.querySelectorAll('[data-media]').forEach(media => {
        const active = media.dataset.media === id;
        media.hidden = !active;
        if (!active) {
          media.querySelectorAll('video').forEach(video => video.pause());
          media.querySelectorAll('iframe').forEach(frame => { const source = frame.src; frame.src = source; });
        }
      });
      this.querySelectorAll('[data-media-target]').forEach(link => link.setAttribute('aria-current', String(link.dataset.mediaTarget === id)));
    }
    async changeOption(link) {
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      const message = this.querySelector('[data-update-message]');
      message.hidden = false;
      message.textContent = this.dataset.loading;
      const nextUrl = new URL(link.href);
      const currentUrl = new URL(location.href);
      if (currentUrl.searchParams.has('view')) nextUrl.searchParams.set('view', currentUrl.searchParams.get('view'));
      const fetchUrl = new URL(nextUrl);
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.abort?.abort();
      this.abort = new AbortController();
      try {
        const response = await fetch(fetchUrl, { signal: this.abort.signal });
        if (!response.ok) throw new Error('section');
        const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = nextDocument.querySelector('[data-product-content]');
        const nextProduct = nextDocument.querySelector('aura-product');
        if (!replacement || !nextProduct) throw new Error('section');
        const oldQuantity = this.querySelector('input[name="quantity"]')?.value;
        const openBlocks = Array.from(this.querySelectorAll('details[open]')).map(detail => detail.closest('[data-block-id]')?.dataset.blockId).filter(Boolean);
        this.querySelector('[data-product-content]').replaceWith(replacement);
        this.dataset.productId = nextProduct.dataset.productId;
        const newQuantity = this.querySelector('input[name="quantity"]');
        if (newQuantity && oldQuantity) {
          const min = Number(newQuantity.min) || 1;
          const step = Number(newQuantity.step) || 1;
          const max = newQuantity.max ? Number(newQuantity.max) : Infinity;
          newQuantity.value = Math.max(min, Math.min(max, min + Math.floor((Number(oldQuantity) - min) / step) * step));
        }
        openBlocks.forEach(id => { const block = Array.from(this.querySelectorAll('[data-block-id]')).find(node => node.dataset.blockId === id); const detail = block?.querySelector('details'); if (detail) detail.open = true; });
        history.replaceState({}, '', nextUrl);
        this.querySelector(`[data-option-value="${link.dataset.optionValue}"]`)?.focus({ preventScroll: true });
        message.hidden = true;
        window.Shopify?.PaymentButton?.init();
        this.dispatchEvent(new CustomEvent('aura:variant-change', { bubbles: true, detail: { productId: this.dataset.productId } }));
      } catch (error) {
        if (error.name !== 'AbortError') {
          message.textContent = this.dataset.error;
          const retry = document.createElement('a');
          retry.href = nextUrl;
          retry.textContent = link.textContent.trim();
          retry.style.textDecoration = 'underline';
          message.append(' ', retry);
        }
      } finally { this.busy = false; this.removeAttribute('aria-busy'); }
    }
    async addToCart(form) {
      if (!form.reportValidity()) return;
      const button = form.querySelector('[name="add"]');
      if (!button || button.disabled || !form.querySelector('[name="id"]')?.value) return;
      this.busy = true;
      const originalLabel = button.textContent;
      const message = form.querySelector('[data-form-message]');
      const cartLink = form.querySelector('[data-cart-link]');
      button.disabled = true;
      button.textContent = this.dataset.loading;
      message.hidden = true;
      cartLink.hidden = true;
      try {
        const response = await fetch(`${this.dataset.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        message.textContent = this.dataset.added;
        message.dataset.error = 'false';
        cartLink.hidden = false;
        this.dispatchEvent(new CustomEvent('aura:cart-change', { bubbles: true, detail: result }));
      } catch (error) { message.textContent = error.message || this.dataset.error; message.dataset.error = 'true'; }
      finally { message.hidden = false; button.disabled = false; button.textContent = originalLabel; this.busy = false; }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aura-product-tabs')) {
    customElements.define('aura-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.buttons = [...this.querySelectorAll('[data-aura-tab]')];
        this.panels = [...this.querySelectorAll('[data-aura-panel]')];
        this.tablist = this.querySelector('[data-aura-tablist]');
        if (!this.buttons.length || !this.tablist) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tablist.addEventListener('click', event => {
          const button = event.target.closest('[data-aura-tab]');
          if (button && this.tablist.contains(button)) this.activate(button);
        }, options);
        this.tablist.addEventListener('keydown', event => {
          const current = this.buttons.indexOf(event.target);
          if (current < 0) return;
          let next = current;
          if (event.key === 'ArrowRight') next = (current + 1) % this.buttons.length;
          else if (event.key === 'ArrowLeft') next = (current - 1 + this.buttons.length) % this.buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.buttons.length - 1;
          else return;
          event.preventDefault();
          this.activate(this.buttons[next]);
          this.buttons[next].focus({ preventScroll: true });
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const button = this.buttons.find(item => item.dataset.blockId === event.detail?.blockId);
          if (button) this.activate(button);
        }, options);
        const header = document.getElementById('header-group');
        this.updateHeader = () => {
          if (header) this.style.setProperty('--aura-tabs-header-height', `${Math.round(header.getBoundingClientRect().height)}px`);
        };
        this.updateHeader();
        if (header) {
          this.headerObserver = new ResizeObserver(this.updateHeader);
          this.headerObserver.observe(header);
        }
        this.activate(this.buttons[0], false);
        this.setAttribute('data-ready', '');
      }
      activate(button, scroll = true) {
        for (const item of this.buttons) {
          const selected = item === button;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        }
        for (const panel of this.panels) panel.hidden = panel.id !== button.getAttribute('aria-controls');
        if (scroll) {
          const panel = this.panels.find(item => !item.hidden);
          if (panel && panel.getBoundingClientRect().top < this.tablist.getBoundingClientRect().bottom) {
            panel.scrollIntoView({ block: 'start', behavior: 'instant' });
          }
          const tabRect = button.getBoundingClientRect();
          const listRect = this.tablist.getBoundingClientRect();
          if (tabRect.left < listRect.left || tabRect.right > listRect.right) {
            this.tablist.scrollBy({ left: tabRect.left - listRect.left - (listRect.width - tabRect.width) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.headerObserver?.disconnect();
        this.controller = null;
        this.headerObserver = null;
        this.removeAttribute('data-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-site-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aura-site-footer')) {
    customElements.define('aura-site-footer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('a[href="#top"]');
          if (!link || !this.contains(link)) return;
          event.preventDefault();
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
          document.querySelector('.page-wrapper')?.scrollTo({ top: 0, behavior });
          window.scrollTo({ top: 0, behavior });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-site-header"] && !Shopify.designMode) return;
  try {
    
  function bindAuraSiteHeader(root){
    if(root.dataset.bound)return;root.dataset.bound='true';
    const dialog=root.querySelector('dialog');
    root.querySelector('.aura-site-menu-open')?.addEventListener('click',()=>dialog.showModal());
    root.querySelector('.aura-site-menu-close')?.addEventListener('click',()=>dialog.close());
    dialog?.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});
    dialog?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>dialog.close()));
  }
  document.querySelectorAll('.aura-site-header').forEach(bindAuraSiteHeader);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.aura-site-header').forEach(bindAuraSiteHeader));
  async function updateAuraBag(){const bag=document.querySelector('.aura-site-bag');if(!bag)return;try{const response=await fetch(bag.getAttribute('href')+'.js',{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();if(Number.isInteger(cart.item_count))document.querySelectorAll('.aura-site-bag span').forEach(span=>span.textContent='('+cart.item_count+')');}catch{}}
  document.addEventListener('aura:cart-change',updateAuraBag);
  document.addEventListener('shopify:cart:lines-update',async event=>{try{await event.promise;}catch{}await updateAuraBag();});
  window.addEventListener('pageshow',event=>{if(event.persisted)updateAuraBag();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
